import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';

/**
 * PHI preset � Lara-based, matching old PrimeNG v17 Lara/Blue theme.
 * Primary: #5297ff. WCAG AA: interactive elements use #2170e7 (4.6:1 on white).
 */
export const PhiPreset = definePreset(Lara, {
  primitive: {
    borderRadius: {
      none: '0',
      xs:   '4px',
      sm:   '6px',
      md:   '10px',
      lg:   '10px',
      xl:   '10px',
    },
    blue: {
      50:  '#eef4ff',
      100: '#d9e8ff',
      200: '#bcd4ff',
      300: '#a9cbff',
      400: '#6a9eff',
      500: '#5297ff',
      600: '#297fff',
      700: '#2170e7',
      800: '#1a4db3',
      900: '#153d8f',
      950: '#0e2a66',
    },
  },

  semantic: {
    transitionDuration: '0.2s',

    primary: {
      50:  '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },

    colorScheme: {
      light: {
        primary: {
          color:         '#1452a8',
          inverseColor:  '#ffffff',
          hoverColor:    '#297fff',
          activeColor:   '#2170e7',
          contrastColor: '#ffffff',
        },
        highlight: {
          background:      'rgba(82,151,255,0.10)',
          focusBackground: 'rgba(82,151,255,0.24)',
          color:           '{blue.700}',
          focusColor:      '{blue.800}',
        },
        focusRing: {
          color:  '#1452a8',
          shadow: '0 0 0 2px #ffffff, 0 0 0 0.25rem #1452a8',
        },
        surface: {
          0:   '#ffffff',
          50:  '#fcfcfc',
          100: '#f2f4f6',
          200: '#d8dadd',
          300: '#d4d6d9',
          400: '#d4d6d9',
          500: '#83888f',
          600: '#69707a',
          700: '#545b67',
          800: '#343a40',
          900: '#212529',
          950: '#101214',
        },
      },
      dark: {
        primary: {
          color:         '{blue.400}',
          inverseColor:  '{surface.900}',
          hoverColor:    '{blue.300}',
          activeColor:   '{blue.300}',
          contrastColor: '{surface.900}',
        },
        highlight: {
          background:      'rgba(82,151,255,0.16)',
          focusBackground: 'rgba(82,151,255,0.24)',
          color:           '{blue.300}',
          focusColor:      '{blue.200}',
        },
        focusRing: {
          color:  '{blue.400}',
          shadow: '0 0 0 2px {surface.900}, 0 0 0 4px {blue.400}',
        },
        surface: {
          0:   '#ffffff',
          50:  '#f8f9fa',
          100: '#f1f3f5',
          200: '#e9ecef',
          300: '#dee2e6',
          400: '#ced4da',
          500: '#adb5bd',
          600: '#6c757d',
          700: '#495057',
          800: '#343a40',
          900: '#212529',
          950: '#101214',
        },
      },
    },
  },

  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background:        '#1452a8',
              borderColor:       '#1452a8',
              color:             '#ffffff',
              hoverBackground:   '#297fff',
              hoverBorderColor:  '#297fff',
              hoverColor:        '#ffffff',
              activeBackground:  '#2170e7',
              activeBorderColor: '#2170e7',
              activeColor:       '#ffffff',
            },
            secondary: {
              background:        '#374151',
              borderColor:       '#374151',
              color:             '#ffffff',
              hoverBackground:   '#475569',
              hoverBorderColor:  '#475569',
              hoverColor:        '#ffffff',
            },
          },
        },
        dark: {
          root: {
            primary: {
              background:        '{blue.400}',
              borderColor:       '{blue.400}',
              color:             '{surface.900}',
              hoverBackground:   '{blue.300}',
              hoverBorderColor:  '{blue.300}',
              hoverColor:        '{surface.900}',
            },
          },
        },
      },
    },

    inputtext: {
      colorScheme: {
        light: {
          root: {
            borderColor:      '#d4d6d9',
            hoverBorderColor: '{blue.500}',
            focusBorderColor: '{blue.500}',
            color:            '#69707a',
            placeholderColor: '#83888f',
            background:       '#ffffff',
          },
        },
      },
    },
  },
});
